import { render } from "./SidebarMenuTwo.vue?vue&type=template&id=3aa92ea1"
import script from "./SidebarMenuTwo.vue?vue&type=script&lang=js"
export * from "./SidebarMenuTwo.vue?vue&type=script&lang=js"

import "./SidebarMenuTwo.vue?vue&type=style&index=0&id=3aa92ea1&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__